export default "__VITE_PUBLIC_ASSET__3aacb13e__"